import './alert.css'

function Success({hide}) {
    return (
        <div id='alert-background' onClick={() => hide()}>
            <div className='alert-modal' onClick={() => hide()}>
                <div className='title'>Success</div>
                <div className='separator'/>
                <div className='content mb-2'>Thank you for your interest. We will contact you as soon as possible</div>
            </div>
        </div>
    )
}

function Failed({hide, content}) {
    return (
        <div id='alert-background' onClick={() => hide()}>
            <div className='alert-modal bad' onClick={() => hide()}>
                <div className='title'>Error</div>
                <div className='separator'/>
                <div className='content mb-2'>{content}</div>
            </div>
        </div>
    )
}

export {Success, Failed};